import { apiClient } from "../lib/api";

export const correctiveActionApi = {
  listCases: (status) => apiClient.get("/corrective-actions", { params: status ? { status } : {} }),
  getCase: (caseId) => apiClient.get(`/corrective-actions/${caseId}`),
  createCase: (payload) => apiClient.post("/corrective-actions", payload),
  updateCase: (caseId, payload) => apiClient.patch(`/corrective-actions/${caseId}`, payload),
  transitionStatus: (caseId, status, note) => apiClient.post(`/corrective-actions/${caseId}/transition`, { status, note }),
  addEvidence: (caseId, label, storage_path) => apiClient.post(`/corrective-actions/${caseId}/evidence`, { label, storage_path }),
  approveCase: (caseId, note) => apiClient.post(`/corrective-actions/${caseId}/approve`, { note }),
  submitCase: (caseId) => apiClient.post(`/corrective-actions/${caseId}/submit`),
  recordFollowUp: (caseId, response) => apiClient.post(`/corrective-actions/${caseId}/follow-up`, { response }),
};
